export const THEME_PREFERENCE_STORAGE = "onland.theme.preference";

const PREFERENCES = ["system", "dark", "light"];
const APPEARANCES = ["dark", "light"];

export function getUrlAppearanceOverride(search, allowed) {
  const values = new URLSearchParams(String(search || "").replace(/^\?/, "")).getAll("appearance");
  const available = Array.isArray(allowed) ? allowed.filter(value => APPEARANCES.includes(value)) : APPEARANCES;

  if (values.length !== 1 || !available.includes(values[0])) return null;
  return values[0];
}

function validPreference(value) {
  return PREFERENCES.includes(value) ? value : "system";
}

function validAppearance(value) {
  return APPEARANCES.includes(value) ? value : "dark";
}

export function chooseEffectiveAppearance({ preference, systemAppearance, allowed, defaultAppearance }) {
  const policy = Array.isArray(allowed) && allowed.filter(value => APPEARANCES.includes(value));
  const available = policy.length ? policy : [validAppearance(defaultAppearance)];
  const requested = validPreference(preference) === "system" ? validAppearance(systemAppearance) : validPreference(preference);

  if (available.includes(requested)) return requested;
  if (available.includes(defaultAppearance)) return defaultAppearance;
  return available[0];
}

export function readLocalAppearancePreference() {
  try {
    const value = globalThis.localStorage?.getItem(THEME_PREFERENCE_STORAGE);
    return PREFERENCES.includes(value) ? value : null;
  } catch {
    return null;
  }
}

export function writeLocalAppearancePreference(preference) {
  if (!PREFERENCES.includes(preference)) return;
  try {
    globalThis.localStorage?.setItem(THEME_PREFERENCE_STORAGE, preference);
  } catch {
    // Local storage is optional in embedded/editor preview contexts.
  }
}
